// Shared styles only. Area-specific stylesheets (each legacy app's main.scss and
// its PrimeReact css) are imported inside the lazy-loaded area Apps so webpack
// code-splits them per area — loading all three globally made the apps' global
// styles conflict (e.g. saga-blue theme was only ever used by the admin panel).
import '@recx/auth/dist/index.css';
import 'primeicons/primeicons.css';
import 'react-toastify/dist/ReactToastify.css';

import { createRoot } from 'react-dom/client';

import App from './App';

const container = document.getElementById('root');

if (!container) {
    throw new Error('Unable to mount ReCX portal: #root was not found.');
}

createRoot(container).render(<App />);
